function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { memo, useRef } from 'react';
import cc from 'classcat';
import { useStore } from '@reactflow/core';
import { shallow } from 'zustand/shallow';
var BackgroundVariant;
(function (BackgroundVariant) {
  BackgroundVariant["Lines"] = "lines";
  BackgroundVariant["Dots"] = "dots";
  BackgroundVariant["Cross"] = "cross";
})(BackgroundVariant || (BackgroundVariant = {}));
function LinePattern(_ref) {
  let color = _ref.color,
    dimensions = _ref.dimensions,
    lineWidth = _ref.lineWidth;
  return /*#__PURE__*/React.createElement("path", {
    stroke: color,
    strokeWidth: lineWidth,
    d: `M${dimensions[0] / 2} 0 V${dimensions[1]} M0 ${dimensions[1] / 2} H${dimensions[0]}`
  });
}
function DotPattern(_ref2) {
  let color = _ref2.color,
    radius = _ref2.radius;
  return /*#__PURE__*/React.createElement("circle", {
    cx: radius,
    cy: radius,
    r: radius,
    fill: color
  });
}
const defaultColor = {
  [BackgroundVariant.Dots]: '#91919a',
  [BackgroundVariant.Lines]: '#eee',
  [BackgroundVariant.Cross]: '#e2e2e2'
};
const defaultSize = {
  [BackgroundVariant.Dots]: 1,
  [BackgroundVariant.Lines]: 1,
  [BackgroundVariant.Cross]: 6
};
const selector = s => ({
  transform: s.transform,
  patternId: `pattern-${s.rfId}`
});
function Background(_ref3) {
  let id = _ref3.id,
    _ref3$variant = _ref3.variant,
    variant = _ref3$variant === void 0 ? BackgroundVariant.Dots : _ref3$variant,
    _ref3$gap = _ref3.gap,
    gap = _ref3$gap === void 0 ? 20 : _ref3$gap,
    size = _ref3.size,
    _ref3$lineWidth = _ref3.lineWidth,
    lineWidth = _ref3$lineWidth === void 0 ? 1 : _ref3$lineWidth,
    _ref3$offset = _ref3.offset,
    offset = _ref3$offset === void 0 ? 2 : _ref3$offset,
    color = _ref3.color,
    style = _ref3.style,
    className = _ref3.className;
  const ref = useRef(null);
  const _useStore = useStore(selector, shallow),
    transform = _useStore.transform,
    patternId = _useStore.patternId;
  const patternColor = color || defaultColor[variant];
  const patternSize = size || defaultSize[variant];
  const isDots = variant === BackgroundVariant.Dots;
  const isCross = variant === BackgroundVariant.Cross;
  const gapXY = Array.isArray(gap) ? gap : [gap, gap];
  const scaledGap = [gapXY[0] * transform[2] || 1, gapXY[1] * transform[2] || 1];
  const scaledSize = patternSize * transform[2];
  const patternDimensions = isCross ? [scaledSize, scaledSize] : scaledGap;
  const patternOffset = isDots ? [scaledSize / offset, scaledSize / offset] : [patternDimensions[0] / offset, patternDimensions[1] / offset];
  return /*#__PURE__*/React.createElement("svg", {
    className: cc(['react-flow__background', className]),
    style: _objectSpread(_objectSpread({}, style), {}, {
      position: 'absolute',
      width: '100%',
      height: '100%',
      top: 0,
      left: 0
    }),
    ref: ref,
    "data-testid": "rf__background"
  }, /*#__PURE__*/React.createElement("pattern", {
    id: patternId + id,
    x: transform[0] % scaledGap[0],
    y: transform[1] % scaledGap[1],
    width: scaledGap[0],
    height: scaledGap[1],
    patternUnits: "userSpaceOnUse",
    patternTransform: `translate(-${patternOffset[0]},-${patternOffset[1]})`
  }, isDots ? ( /*#__PURE__*/React.createElement(DotPattern, {
    color: patternColor,
    radius: scaledSize / offset
  })) : ( /*#__PURE__*/React.createElement(LinePattern, {
    dimensions: patternDimensions,
    color: patternColor,
    lineWidth: lineWidth
  }))), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "100%",
    height: "100%",
    fill: `url(#${patternId + id})`
  }));
}
Background.displayName = 'Background';
var Background$1 = /*#__PURE__*/memo(Background);
export { Background$1 as Background, BackgroundVariant };